"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const sk_1 = __importDefault(require("date-fns/locale/sk")); //
const dateSkSK = {
    name: 'sk-SK',
    locale: sk_1.default
};
exports.default = dateSkSK;
